<!-- SET Z-COORDINATE MODAL -->
<div id="setZCoordinateDialog" appDraggable dragTarget="#setZCoordinateDialog" dragHandle="#setZCoordinateDialogHeader" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="setZCoordinateModalLabel">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div id="setZCoordinateDialogHeader" class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">X</span></button>
        <h4 class="modal-title">SET Z-COORDINATE</h4>
      </div>
      <div class="modal-body form-group">
        <p>Enter the z-coordinate</p>
        <input [(ngModel)]="mZCoordinate" type="text" size="20" class="form-control">
        <select [(ngModel)]="mMeasurementType" class="form-control">
          <option *ngFor="let type of mAvailableMeasurementTypes" [ngValue]="type">
            {{type}}
          </option>
        </select>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-default" data-dismiss="modal">CANCEL</button>
        <button type="button" class="btn btn-primary" (click)="setZCoordinateClicked()">SET</button>
      </div>
    </div>
  </div>
</div>
